import PropTypes from 'prop-types';

const Header = ({
  timebar,
  sticky: { isSticky, sidebarWidth, headerHeight } = {},
}) => {
  return (
    <div style={isSticky ? { paddingTop: headerHeight } : {}}>
      <div
        className={`rt-sidebar__header bg-[#F7F7F7] ${
          isSticky ? 'fixed top-0 z-[2]' : ''
        }`}
        style={isSticky ? { width: sidebarWidth } : {}}
      >
        {(timebar ?? [])?.map(({ id, title, useAsGrid }) => (
          <div
            key={id}
            className={`pt-4 font-SFProDisplay_Bold ml-4 ${
              useAsGrid ? 'invisible' : ''
            }`}
          >
            {title ?? ''}
          </div>
        ))}
      </div>
    </div>
  );
};

Header.propTypes = {
  sticky: PropTypes.shape({
    isSticky: PropTypes.bool.isRequired,
    headerHeight: PropTypes.number.isRequired,
    sidebarWidth: PropTypes.number.isRequired,
  }),
  timebar: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
    }).isRequired
  ).isRequired,
};

export default Header;
